import { render, staticRenderFns } from "./EtaVisaRequestList.vue?vue&type=template&id=0db4646a&"
import script from "./EtaVisaRequestList.vue?vue&type=script&lang=js&"
export * from "./EtaVisaRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports